

@if(checkForOdin){
<app-where-is-steel></app-where-is-steel>
}@else{
<main class="container-fluid">
  <section class="sec-main row">
    <article class="title align-self-center" style="width:850px; padding-top: 32px; padding-bottom: 32px">
      <h4 class="text-primary">Welcome {{authService.isLoggedIn ? username : ''}}</h4>
      <h1 style="margin-bottom: 80px;">Smarter decisions start with better coil data</h1>
      @if (authService.isLoggedIn) {
      <div class="d-flex justify-content-between">
        <article class="search-panel bg-white py-2 px-3 flex-fill">
          <div class="d-flex gap-4 my-3">
            <h4 class="selectable fs-5" [class]="selectedSearch === 1 ? 'text-primary fw-bold' : 'disabled-text'"
              (click)="searchCoilOrOrder(1)" (keydown.enter)="searchCoilOrOrder(1)" tabindex="1">Find your coil</h4>
            <h4 class="selectable fs-5" [class]="selectedSearch === 2 ? 'text-primary fw-bold' : 'disabled-text'"
              (click)="searchCoilOrOrder(2)" (keydown.enter)="searchCoilOrOrder(2)" tabindex="2">Find your order</h4>
          </div>
          <div class="search">
            <input type="text" class="search-form form-control pr-5 text-search" id="searchCoil"
              (focus)="showSuggestions()" (blur)="hideSuggestions()"
              [placeholder]="selectedSearch === 1 ? 'Search for coil number, product type or steel grade' : 'Search for order number, product type or steel grade'"
              (keydown.enter)="searchAndNavigate()" [(ngModel)]="searchText" tabindex="3" />
            <div class="suggestion-box" *ngIf="showSuggestion">
              <div class="recent-search-text">
                <b>Recent Search</b>
              </div>
              <div class="suggestion-item" *ngFor="let suggestion of suggestions"
                (click)="selectSuggestion(suggestion.searchText,selectedSearch)">
                <span class="material-symbols-outlined">
                  schedule
                </span>
                <div class="suggestion-left-content">{{ suggestion.searchText }}</div>
                <div class="suggestion-right-content">{{
                  suggestion.fieldNames.map(toReadableHistorySuggestionFormat).join(', ') }}</div>
              </div>

            </div>
            <button type="button" class="btn btn-primary btn-sm btn-panel btn-search align-items-center"
              (click)="searchAndNavigate()" tabindex="4">
              <span class="material-icons-outlined btn-icon">search</span><span class="btn-text">
                @if (selectedSearch==1){
                @if ((searchText | customTrimPipe).length == 0){
                Overview
                }
                @else{
                Search
                }
                }
                @if (selectedSearch==2){
                @if ((searchText | customTrimPipe).length == 0){
                Overview
                }
                @else{
                Search
                }
                }
              </span>
            </button>
          </div>
        </article>
      </div>
      }
    </article>
  </section>

  <!-- Content -->
  <section>
    <h1 class="title-two text-primary my-5">How does it work?</h1>
    <div class="info-wrapper">
      <div class="step row">
        <img src="assets/images/search-result-1.png" alt="Search Result 1" class="col-6 step-img">
        <div class="my-5 col-5 align-self-center">
          <div class="step-info-wrapper">
            <h3 class="step-info-title text-primary mb-4">1. Explore Effortlessly</h3>
            <p class="text-justify">Type any keyword and use multiple filters to quickly see your desired coil.</p>
          </div>
        </div>
      </div>
      <div class="step row">
        <img src="assets/images/search-result-2.png" alt="Search Result 2" class="col-6 step-img">
        <div class="step-info-wrapper my-5 col align-self-center">
          <h3 class="step-info-title text-primary mb-4">2. Uncover Insights</h3>
          <p class="text-justify">View detailed width and thickness plots for each search result to quickly identify and
            compare product characteristics within your order.</p>
        </div>
      </div>
      <div class="step row">
        <img src="assets/images/search-result-3.png" alt="Search Result 3" class="col-6 step-img">
        <div class="step-info-wrapper my-5 col align-self-center">
          <h3 class="step-info-title step-info-title-last text-primary mb-4">3. Download & Analyze</h3>
          <p class="text-justify">Conduct in-depth analyses of your products by securely downloading width and thickness
            data along the length of the coil in your preferred format.</p>
        </div>
      </div>
    </div>
  </section>
  <ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
    <p style="font-size: 20px; color: white">Loading...</p>
  </ngx-spinner>
</main>
}